import "../Style/Dmstack.css";

import androidImg from "../assets/android.png";
import dartImg from "../assets/dart.png";
import firebaseImg from "../assets/firebase.png";
import flutterImg from "../assets/flutter.png";
import githubImg from "../assets/github.png";
import kotlinImg from "../assets/kotlin.png";
import vscodeImg from "../assets/vscode.png";
import postmanImg from "../assets/postman.png";

/* VALUE BOX ICONS */
import commitmentImg from "../assets/commitment.png";
import excellenceImg from "../assets/excellence.png";
import passionImg from "../assets/passion.png";
import priorityImg from "../assets/priority.png";

const tools = [
  { src: kotlinImg, alt: "Kotlin" },
  { src: vscodeImg, alt: "VS Code" },
  { src: postmanImg, alt: "Postman" },
  { src: androidImg, alt: "Android" },
  { src: githubImg, alt: "GitHub" },
  { src: firebaseImg, alt: "Firebase" },
  { src: flutterImg, alt: "Flutter" },
  { src: dartImg, alt: "Dart" },
];

export default function DmStack() {
  const items = [...tools, ...tools];

  return (
    <section className="dm-stack-section">
      <div className="dm-stack-pattern" aria-hidden="true" />

      <div className="dm-stack-inner">
        <div className="dm-stack-badge">
          <div className="dm-stack-badge-ring" aria-hidden="true" />
          <h2 className="dm-stack-badge-title">Technology Stack</h2>
          <span className="dm-stack-badge-subtitle">
            Digital Marketing Tools
          </span>
        </div>

        <div className="dm-stack-right">
          <span className="dm-stack-eyebrow">Tools &amp; Technology</span>

          <h3 className="dm-stack-info-heading">
            Our Digital Marketing Tech Stack
          </h3>

          <p className="dm-stack-info-desc">
            We use modern digital marketing strategies and tools to grow your
            brand online. Our campaigns increase visibility, attract the
            right audience, and drive business growth.
          </p>

          <div className="dm-stack-marquee-card">
            <div className="dm-stack-marquee-outer">
              <div className="dm-stack-marquee-track">
                {items.map((tool, i) => (
                  <div className="dm-stack-cell" key={i}>
                    <div className="dm-stack-icon-wrap">
                      <img
                        src={tool.src}
                        alt={tool.alt}
                        className="dm-stack-icon"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BLUE VALUE BOX */}
      <div className="dm-value-wrapper">
        <div className="dm-value-box">
          <div className="dm-value-card">
            <img
              src={commitmentImg}
              alt="Commitment"
              className="dm-value-image"
            />
            <h4 className="dm-value-title">Commitment</h4>
            <p className="dm-value-desc">
              We don't stop until we reach our goals.
            </p>
          </div>

          <div className="dm-value-card">
            <img
              src={excellenceImg}
              alt="Excellence"
              className="dm-value-image"
            />
            <h4 className="dm-value-title">Excellence</h4>
            <p className="dm-value-desc">
              We don't settle for less, as we have set our standards high.
            </p>
          </div>

          <div className="dm-value-card">
            <img
              src={passionImg}
              alt="Passion"
              className="dm-value-image"
            />
            <h4 className="dm-value-title">Passion</h4>
            <p className="dm-value-desc">
              We go beyond to develop tools that empower customers.
            </p>
          </div>

          <div className="dm-value-card">
            <img
              src={priorityImg}
              alt="Priority"
              className="dm-value-image"
            />
            <h4 className="dm-value-title">Priority</h4>
            <p className="dm-value-desc">
              Customers are our top priority. Customer satisfaction is our
              goal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}